import React from "react";
import { Dropdown } from 'primereact/dropdown';
import './InputLista.scss'
const InputLista = ({style,lecturaEscritura="E",value,onChange,options,placeholder,disabled=false,titulo,optionLabel='name',id,obligatory = true,className ,onClick = ()=>{}})=>
{
    return(
        <div className={`InputLista ${className}`} style={style}>
            <div className="contenedorTitulo">
                <div className="obligatorio">{obligatory?"*":""} </div>
                <div className="titulo">{titulo}</div>
            </div>
            <Dropdown  onClick ={onClick} className="lista" disabled={lecturaEscritura == "L" || disabled} id={id} value={value} onChange={onChange} options={options} optionLabel={optionLabel} placeholder={placeholder} filter 
            ></Dropdown>
        </div>
    )
}
export default InputLista